import PropTypes from 'prop-types';
import DebugLogger from "../../../helpers/DebugLogger";

import "./Toggle.scss";

import { IconJsxer } from "../../../helpers/IconHelper";

/**
 * Toggle is a modern toggle switch component with optional icons and two variants.
 * It doesn't automatically toggle, you must provide a setFunc function and update it's currentState prop.
 * @param {*} props 
 * @returns 
 */
const Toggle = (props) => {
    const { id, currentState, toggleFunc, enabled, variant, iconOn, iconOff, overrideBg } = props;
    const checked = currentState === 'checked' || currentState === true;

    if (toggleFunc === null) {
        DebugLogger.warn('You should provide a function called `toggleFunc(fieldVal[, id])` to Toggle.');
    }

    const toggle = (e) => {
        if (toggleFunc) {
            toggleFunc(e, id);
        }
    }

    return (
        <div className={`toggle-content ${variant}`}>
            <div 
                onClick={enabled ? toggle : null} 
                className={`toggle-holder ${variant} ${enabled ? 'button-active' : 'disabled'}`}
            >
                <div className="toggle-outer">
                    <div 
                        className={`toggle-track ${checked ? 't-on' : 't-off'}`} 
                        style={{backgroundColor: overrideBg ? overrideBg[checked ? 'on' : 'off'] : null}}
                    >
                        {iconOff && (
                            <div className="toggle-icon icon-off">
                                {iconOff}
                            </div>
                        )}
                        {iconOn && (
                            <div className="toggle-icon icon-on">
                                {iconOn}
                            </div>
                        )}
                        <div className={`toggle-switch ${checked ? 's-on' : 's-off'}`}>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

Toggle.propTypes = {
    id: PropTypes.string,
    currentState: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    toggleFunc: PropTypes.func,
    enabled: PropTypes.bool,
    variant: PropTypes.oneOf(['default', 'compact', 'topbar']),
    iconOn: PropTypes.node,
    iconOff: PropTypes.node,
    overrideBg: PropTypes.object,
};

Toggle.defaultProps = {
    id: '',
    currentState: false,
    toggleFunc: null,
    enabled: true,
    variant: 'default',
    iconOn: null,
    iconOff: null,
    overrideBg: null,
}

export default Toggle;
